var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { getPastShiftsByParticipantIdFunctionDef } from '../../../../backend/features/shift/shared';
import { defaultFetcherOptions } from '../../../../ui/utils/defaultFetcherOptions';
import { handleErrorSnackbar } from '@juvare/common-web-ui/SnackbarHelper';
import { useTypedPlatformFunction } from '@juvare/platform-sdk-react/ui/features/typed-platform-functions';
import React from 'react';
import useSWR from 'swr';
export const shiftsFetchKey = 'shifts';
export const usePastShiftsByParticipantId = ({ participantId, missionId, isVolunteerView, limit, offset, }) => {
    const getPastShiftsByParticipantIdPlatformFn = useTypedPlatformFunction(getPastShiftsByParticipantIdFunctionDef);
    const fetchPastShiftsByParticipantId = (participantId) => {
        return getPastShiftsByParticipantIdPlatformFn({
            participantId,
            missionId,
            limit,
            offset,
        }); // TODO: Remove Type Casting after PLAT-2704;
    };
    const { data: shiftsData, mutate, isLoading, error, } = useSWR([shiftsFetchKey, participantId, isVolunteerView, limit, offset], (_a) => __awaiter(void 0, [_a], void 0, function* ([, paramsMissionId]) {
        return fetchPastShiftsByParticipantId(paramsMissionId).catch(handleErrorSnackbar);
    }), defaultFetcherOptions);
    const fetchShifts = React.useCallback(() => __awaiter(void 0, void 0, void 0, function* () {
        yield mutate();
    }), [mutate]);
    return {
        fetchShifts,
        shifts: shiftsData === null || shiftsData === void 0 ? void 0 : shiftsData.data,
        total: shiftsData === null || shiftsData === void 0 ? void 0 : shiftsData.total,
        ids: shiftsData === null || shiftsData === void 0 ? void 0 : shiftsData.ids,
        isLoading,
        error,
    };
};
